"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createYouTubeContentStyle;

function createYouTubeContentStyle(_ref) {
  var videoHeight = _ref.videoHeight;
  return {
    border: 0,
    height: videoHeight,
    width: '100%'
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJjcmVhdGVZb3VUdWJlQ29udGVudFN0eWxlIiwidmlkZW9IZWlnaHQiLCJib3JkZXIiLCJoZWlnaHQiLCJ3aWR0aCJdLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL1N0eWxlcy9TdHlsZVNldC9Zb3VUdWJlQ29udGVudC50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBTdHJpY3RTdHlsZU9wdGlvbnMgfSBmcm9tICdib3RmcmFtZXdvcmstd2ViY2hhdC1hcGknO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBjcmVhdGVZb3VUdWJlQ29udGVudFN0eWxlKHsgdmlkZW9IZWlnaHQgfTogU3RyaWN0U3R5bGVPcHRpb25zKSB7XG4gIHJldHVybiB7XG4gICAgYm9yZGVyOiAwLFxuICAgIGhlaWdodDogdmlkZW9IZWlnaHQsXG4gICAgd2lkdGg6ICcxMDAlJ1xuICB9O1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBRWUsU0FBU0EseUJBQVQsT0FBd0U7RUFBQSxJQUFuQ0MsV0FBbUMsUUFBbkNBLFdBQW1DO0VBQ3JGLE9BQU87SUFDTEMsTUFBTSxFQUFFLENBREg7SUFFTEMsTUFBTSxFQUFFRixXQUZIO0lBR0xHLEtBQUssRUFBRTtFQUhGLENBQVA7QUFLRCJ9